import { useEffect, useState } from 'react';
import { useDatabase } from './useDatabase';

export interface ReservationDetails {
  id: string;
  resourceId: string;
  /** A SchedulingEpoch — either `{ type: "Day", day }` or `{ type: "Days", start_inclusive, end_inclusive }`. */
  when: any;
  /** NodeMatcher describing what the reservation is for. `null` means the resource is blocked. */
  object: any | null;
  remark: string | undefined;
  reservedBy: string | undefined;
  isBlock: boolean;
}

export function useResourceReservations(resourceId?: string) {
  const { database, loading: databaseLoading } = useDatabase();
  const [reservations, setReservations] = useState<ReservationDetails[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!database) {
      setLoading(false);
      return;
    }

    try {
      const all = database.resource_reservations();
      const list: ReservationDetails[] = Object.entries(all).map(([id, r]: [string, any]) => ({
        id,
        resourceId: r.resource_id(),
        when: r.when(),
        object: r.object(),
        remark: r.remark() ?? undefined,
        reservedBy: r.reserved_by() ?? undefined,
        isBlock: r.is_block(),
      }));
      const filtered = resourceId
        ? list.filter((r) => r.resourceId === resourceId)
        : list;
      setReservations(filtered);
      setError(null);
    } catch (err) {
      console.error('Error fetching resource reservations:', err);
      setError(`Error fetching resource reservations: ${err}`);
      setReservations([]);
    } finally {
      setLoading(false);
    }
  }, [database, resourceId]);

  return { reservations, loading: loading || databaseLoading, error };
}
